<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="bg-white p-3">
          <h5 class="card-title fw-bold mb-0">Data Sources</h5>
        </div>  
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        
        <div class="d-sm-flex align-items-center">
        </div>
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          
          <button v-if="this.currentPermissions?.includes('platformIntegration.manage')" @click="openAddQwilrDataSourceBox" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          Add Data Source
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <colgroup>
              <col style="width: 33%;">
              <col style="width: 33%;">
              <col style="width: 33%;">
              <col style="width: 1%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Data Source Name
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Provider
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Connection String
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dataSource in qwilrDataSources" :key="dataSource.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ dataSource.dataSourceName }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ getEnumText(dataSource.provider) }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ dataSource.connectionString }}
                </th>
                
                <td class="shadow-none lh-1 fw-medium text-end pe-0" v-if="this.currentPermissions?.includes('platformIntegration.manage')">
                  <div class="dropdown">
                    <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="deleteDataSource(dataSource.id)"
                          ><i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Delete</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="openUpdateQwilrDataSourceBox(dataSource)"
                          ><i
                            class="flaticon-edit lh-1 me-8 position-relative top-1"
                          ></i>
                          Update</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ qwilrDataSources.length }}</span> out of
            <span class="fw-bold">{{ totalQwilrDataSources }}</span> results
          </p>
        </div>
      </div>

      <Lightbox v-if="showAddQwilrDataSourceBox" @close="closeAddQwilrDataSourceBox">
        <AddQwilrDataSource @dataSourceAdded="handleDataSourceAdded" @close="closeAddQwilrDataSourceBox"/>
      </Lightbox>
      <Lightbox v-if="showUpdateQwilrDataSourceBox" @close="closeUpdateQwilrDataSourceBox">
        <UpdateQwilrDataSource :dataSource="this.selectedDataSource" @dataSourceUpdated="handleDataSourceUpdated" @close="closeUpdateQwilrDataSourceBox"/>
      </Lightbox>
    </div>

  </template>
  
  <script>
  import { GetQwilrDataSources, DeleteQwilrDataSourceById } from '@/core/services/entities/qwilr.service'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Lightbox from '@/components/Common/LightboxWrapper.vue';
  import AddQwilrDataSource from "./AddQwilrDataSource.vue";
  import UpdateQwilrDataSource from "./UpdateQwilrDataSource.vue";
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';
  import { Provider} from "@/core/constant/QwilrDataSourceProvider";
  import { mapGetters} from 'vuex'

  export default {
    name: "QwilrDataSource",
    components: {
        Lightbox,
        AddQwilrDataSource,
        UpdateQwilrDataSource
    },
    data() {
      return {
        searchQuery: "", 
        qwilrDataSources: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalQwilrDataSources: 0, 
        totalPages: 1, 
        showAddQwilrDataSourceBox: false,
        selectedDataSource:null,
        showUpdateQwilrDataSourceBox: false
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchQwilrDataSources(filter = "") {
        let isBlock=false;
        let data = await GetQwilrDataSources();
        if(data)
        {
          this.qwilrDataSources = data.qwilrDataSources;
          this.totalQwilrDataSources = data.qwilrDataSources.length;
        }

      },
      openAddQwilrDataSourceBox(){
        this.showAddQwilrDataSourceBox=true;
      },
      openUpdateQwilrDataSourceBox(dataSource){
        this.selectedDataSource=dataSource;
        this.showUpdateQwilrDataSourceBox=true;
      },
      closeAddQwilrDataSourceBox(){
        this.showAddQwilrDataSourceBox=false;
      },
      closeUpdateQwilrDataSourceBox(){
        this.showUpdateQwilrDataSourceBox=false;
      },
      handleDataSourceAdded(){
        this.fetchQwilrDataSources("");
      },
      handleDataSourceUpdated(){
        this.fetchQwilrDataSources("");
      },
      getEnumText(value) {
        const entry = Object.entries(Provider).find(([key, val]) => val === Number(value));
        return entry ? entry[0] : "Unknown"; 
      },
      async deleteDataSource(id) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: id };
              let response = await DeleteQwilrDataSourceById(payload);  
              if (response.status === 200) {
                toast.success('Data source deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchQwilrDataSources("");
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              console.log(errorMessage);
              toast.error(`Failed to delete data source: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Data source deletion canceled.', { timeout: 2000 });
          }
        });

      }
    },
    computed:{...mapGetters(['allowAdd', 'currentPermissions'])},
    created() {
      this.fetchQwilrDataSources("");
    }
  };
  </script>


  